import { useState } from 'react';
import { Stack } from '@mui/material';
import { MonitoringAssortment } from '@retail/monitoring-assortment/types';
import { useSelectedCompetitors } from '@retail/retailer/data-access';
import { useMonitoringAssortmentItems } from '@retail/monitoring-assortment/context';
import { MonitoringAssortmentTable } from '@retail/products/components';
import { MonitoringAssortmentFilterContainer } from './MonitoringAssortmentFilterContainer';
import { useFilters } from '@retail/products/hooks';

interface Props {
  selectedAssortment: MonitoringAssortment;
  showFilters: boolean;
  setItemToView: (item?: number) => void;
  toggleAddItemsModal: () => void;
}

export function MonitoringAssortmentContainer({
  selectedAssortment,
  showFilters,
  setItemToView,
  toggleAddItemsModal,
}: Props) {
  const [toggleVat, setToggleVat] = useState(true);

  const competitors = useSelectedCompetitors();

  const { filters } = useFilters(['productGroupNumbers', 'searchQuery']);

  const {
    result: { assortmentItems, totalItems },
    pagination,
    isFetching,
  } = useMonitoringAssortmentItems({
    assortmentId: selectedAssortment.id,
    competitors,
    groupNumbers: filters.productGroupNumbers,
    query: filters.searchQuery !== '' ? filters.searchQuery ?? undefined : undefined,
  });

  return (
    <Stack flexGrow={1} direction="row" overflow="hidden">
      <MonitoringAssortmentTable
        items={assortmentItems}
        totalItems={totalItems}
        pagination={pagination}
        includeVat={toggleVat}
        openAddItemsDialog={toggleAddItemsModal}
        competitors={competitors}
        setItemToView={setItemToView}
        loading={isFetching}
      />

      <MonitoringAssortmentFilterContainer
        showFilters={showFilters}
        toggleVat={toggleVat}
        setToggleVat={setToggleVat}
      />
    </Stack>
  );
}
